import { memo, useRef } from 'react'
import { useField, UseFieldConfig } from 'react-final-form'

import { OrderCreatePointOperation } from '../components/OrderCreatePointOperation'
import { OrderCreateOperationForm } from '../components/OrderCreatePointOperation/types'

interface IProps extends Pick<UseFieldConfig<OrderCreateOperationForm[]>, 'validate'> {
  name: string
  pointType: 'departure' | 'destination'
  className?: string
  terminalId?: string
}

export const FieldOrderCreatePointOperation = memo<IProps>(function FieldOrderCreatePointOperation({
  name,
  pointType,
  className,
  terminalId,
  validate
}) {
  const { input, meta } = useField<OrderCreateOperationForm[]>(name, {
    validate
  })

  const onChangeRef = useRef(input.onChange)
  const valueRef = useRef(input.value)

  onChangeRef.current = input.onChange
  valueRef.current = input.value

  if (!terminalId) {
    return null
  }

  return (
    <div className={className}>
      <OrderCreatePointOperation
        onChange={onChangeRef.current}
        pointType={pointType}
        terminalId={terminalId}
        value={valueRef.current}
      />

      {meta.touched && meta.error && (
        <div className="text-error mt-2 text-label-md">
          {typeof meta.error === 'string' ? meta.error : 'Необходимо выбрать услуги'}
        </div>
      )}
    </div>
  )
})
